<p-dialog *ngIf="printJobItem" [(visible)]="printJobItem" [closable]="true" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [style]="{ width: '50vw' }">
	<ng-template pTemplate="header">
		<fa-icon [icon]="['far', 'print-magnifying-glass']" class="me-4" size="lg" (click)="app.copyMessage(printOrder.key)"></fa-icon>
		{{ printJobItem.kitchenPrintJob.check }} - {{ device?.name }}
	</ng-template>

	<div class="d-flex flex-column">
		<div class="p-grid">
			<div class="col-6">
				{{ printJobItem.kitchenPrintJob.check }}
			</div>
			<div class="col-6">
				{{ printJobItem.kitchenPrintJob.table }}
			</div>
		</div>
		<div class="p-grid">
			<div class="p-col">
				{{ printJobItem.kitchenPrintJob.server }}
			</div>
			<div class="p-col">
				{{ app.moment(printJobItem.kitchenPrintJob.time).format("l LT") }}
			</div>
		</div>
		<ng-container *ngFor="let item of printJobItem.kitchenPrintJob.items">
			<div class="p-grid d-flex ms-5">
				<div class="p-col-12" [ngClass]="item.type === 'Child' ? 'ms-5 text-danger' : 'ms-2'">
					{{ item.remoteName }}
				</div>
			</div>
		</ng-container>
		<div class="p-grid">
			<div class="p-col">
				{{ device?.name }}
			</div>
		</div>
		<div class="p-grid">
			<div class="p-col">Order displayed at {{ app.moment(printOrder.created).format("l LT") }}</div>
			<div class="p-col">Status: {{ printOrder.status }} @ {{ app.moment(printOrder.updated).format("l LT") }}</div>
		</div>
		<div class="p-grid" *ngIf="printOrder.status === 'bumped'">
			<div class="p-col">Ticket time {{ printOrder.duration }} minutes</div>
			<div class="p-col"></div>
		</div>
	</div>
	<ng-template pTemplate="footer">
		<app-record-control-footer
			[hideDelete]="true"
			[hideSave]="true"
			(onCancelChange)="printJobItemChange.emit(undefined); printJobItem = undefined"
		></app-record-control-footer>
	</ng-template>
</p-dialog>
